export default "__VITE_ASSET__DXu6f9SK__"